// extracted by mini-css-extract-plugin
export default {"image":"Card_image__tN1Li","card":"Card_card__3Y99f","description":"Card_description__xIAum"};